export const batchChoices = {
  COSMOS_2018: "2018 Cosmos",
  SPECIAL_2018: "2018 Special contracts",
  SUMMER_EXP_2019: "2019 Summer Experienced",
  SUMMER_INTERN_2019: "2019 Summer Interns",
  SUMMER_NEWGRAD_2019: "2019 Summer New Grads",
  FOTR_2020: "2020-03 FOTR",
  WINTER_2020: "2020-10 WINTER",
  EVEREST_2021: "2021 Everest",
  EVEREST_2021_2: "2021 Everest 2",
  EVEREST_2021_3: "2021 Everest 3",
  EVEREST_2021_4: "2021 Everest 4",
  EVEREST_2021_5: "2021 Everest 5",
  WONDER_NEWGRAD_2021: "2021 Wonder New Grad",
  WONDER_EXP_2021: "2021 Wonder Experienced",
  WONDER_SWITCH_2021: "2021 Wonder Switchers",
  EVEREST_2022_6: "2022 Everest 6",
  EVEREST_2022_7: "2022 Everest 7",
  EVEREST_2022_8: "2022 Everest 8",
  EVEREST_2022_9: "2022 Everest 9",
  WONDER_NEWGRAD_2022: "2022 Wonder New Grad",
  EVEREST_2023_10: "2023 Everest 10",
  EVEREST_2023_11: "2023 Everest 11",
  EVEREST_2023_12: "2023 Everest 12",
  EXPEDITION_2023_0: "2023 Expedition 0",
  EXPEDITION_2023_1: "2023 Expedition 1",
  EXPEDITION_2023_2: "2023 Expedition 2",
  WONDER_NEWGRAD_2023: "2023 Wonder New Grads",
  EXPEDITION_2024_3: "2024 Expedition 3",
  EXPEDITION_2024_4: "2024 Expedition 4",
  EXPEDITION_2024_5: "2024 Expedition 5",
  EXPEDITION_2024_6: "2024 Expedition 6",
  EXPEDITION_2025_7: "2025 Expedition 7",
  EXPEDITION_2025_8: "2025 Expedition 8",
  EXPEDITION_2025_9: "2025 Expedition 9",
  EXPEDITION_2025_10: "2025 Expedition 10",
  EXPEDITION_2025_11: "2025 Expedition 11"
} as const;

export const contractTypeChoices = {
  ISA_STANDARD: "ISA Standard",
  ISA_SPECIAL: "ISA Special",
  MONTHLY_SUBSCRIPTION: "Monthly Subscription"
} as const;

export const graduationStatusChoices = {
  CURRENT_FELLOW: "Current fellow",
  QUIT_REMOVED: "Quit/removed before graduation",
  READY_FOR_REFERRAL: "Ready for first referral",
  FINISHED_ALGO_RESUME: "Finished Algorithms and Resume stages",
  GRADUATED_FULL: "Graduated the full program",
  NEVER_APPEARED: "Never appeared",
  SPECIAL_CASE: "Special case",
  GRADUATED_MINI: "Graduated mini program",
  EXPERIMENT: "Experiment",
  CURRENT_FELLOW_2: "Current fellow"
} as const;

export const relationshipChoices = {
  HAPPY_ENGAGED: "We are happy, they are very engaged",
  HAPPY_DISTANT: "We are happy, they are slightly distant",
  HAPPY_NOT: "We are happy, they are not",
  QUIETED_DOWN: "We quieted down",
  JUST_GRADUATED: "Just graduated",
  CURRENT_FELLOW: "Current fellow",
  STOPPED_MOTIVATION: "We stopped: motivation",
  STOPPED_CULTURE: "We stopped: culture match",
  STOPPED_ETHICS: "We stopped: different ethics",
  STOPPED_MISC: "We stopped: misc",
  EXPERIMENT: "2019-08 experiment",
  QUIT_PERSONAL: "They quit for personal reasons"
} as const;

export const programStatusChoices = {
  CURRENT_NOT_APPLYING: "Current fellow: not yet applying",
  CURRENT_FELLOW: "Current fellow",
  CURRENT_SPECIAL: "Current fellow: special circumstances",
  PAUSED_BEFORE_APPLYING: "Agreed to pause before applying",
  DISAPPEARED_BEFORE_APPLYING: "Disappeared before applying",
  QUIT_BEFORE_APPLYING: "Informed & quit before applying",
  EXPELLED: "Expelled",
  CURRENT_ACTIVELY_APPLYING: "Current fellow: actively applying",
  GRADUATED_PAUSED_ACTIVE: "Graduated, paused applying, contract active",
  GRADUATED_CONTRACT_EXPIRED: "Graduated, contract expired",
  GRADUATED_NON_QUALIFYING: "Graduated, signed a non-qualifying offer",
  GRADUATED_QUALIFYING: "Graduated, signed a qualifying offer",
  SPECIAL_2018: "2018 special contracts",

  SUSPENDED: "Suspended"
} as const;

export const degreeStatusChoices = {
  YES: "Yes",
  YES_INCOMPLETE: "Yes (Incomplete)",
  NO: "No"
} as const;

// Type for values of each choice object
export type BatchChoice = typeof batchChoices[keyof typeof batchChoices];
export type ContractTypeChoice = typeof contractTypeChoices[keyof typeof contractTypeChoices];
export type GraduationStatusChoice = typeof graduationStatusChoices[keyof typeof graduationStatusChoices];
export type RelationshipChoice = typeof relationshipChoices[keyof typeof relationshipChoices];
export type ProgramStatusChoice = typeof programStatusChoices[keyof typeof programStatusChoices];
export type DegreeStatusChoice = typeof degreeStatusChoices[keyof typeof degreeStatusChoices];

// Type for fellow data that combines all choices
export interface FellowData {
  id: number;
  legal_name: string;
  batch: BatchChoice;
  contract_type: ContractTypeChoice;
  outtalent_graduation_status: GraduationStatusChoice;
  outtalent_program_status: ProgramStatusChoice;
  outtalent_relationship: RelationshipChoice;
  previous_annualised_salary: string;
  previous_annualised_equity: string;
  staff_comments: string;
  first_referral_date: string;
  user: number;
  degree_status?: DegreeStatusChoice;
  internal_comments: InternalComment[];
} 

interface InternalComment {
  id: number;
  comment: string;
  created_at: string;
  updated_at: string;
  fellow_data: number;
  created_by: {
    id: number;
    first_name: string;
    last_name: string;
    avatar_image?: string;
    username: string;
  }
}